import { pseudoTagStringFromGQL, pseudoTagStringToGQL } from 'utils/coercionUtils';
import { FIELD_NAMES, FIELD_TYPES } from 'utils/constants';

const setNameByType = (obj) => {
  const { type, name } = obj;
  return type === FIELD_TYPES.PICKLIST_VALUE_OPT_IN ? name : FIELD_NAMES.LEAD_SHARE_OPT_IN;
};

const getNameByType = (obj) => {
  const { type, name } = obj;
  return type === FIELD_TYPES.PICKLIST_VALUE_OPT_IN ? name : FIELD_NAMES.CONSENT_NON_GDPR;
};

function fromGQL(obj) {
  const name = getNameByType(obj);
  const { value, ...returnableField } = obj;
  const optInData = { ...value };

  optInData.hasDisclaimer = optInData.disclaimer.length > 0;
  optInData.hasCheckbox = optInData.checkboxText.length > 0;
  optInData.disclaimer = pseudoTagStringFromGQL(optInData.disclaimer);
  optInData.checkboxText = pseudoTagStringFromGQL(optInData.checkboxText);

  return {
    ...returnableField,
    name,
    editors: {
      optInData: {
        ...optInData,
      },
    },
  };
}

function overrideFromGQL(override) {
  const { value, ...returnableField } = override;
  const optInData = { ...value };

  if (optInData.disclaimer) {
    optInData.disclaimer = pseudoTagStringFromGQL(optInData.disclaimer);
  } else {
    delete optInData.disclaimer;
  }
  if (optInData.checkboxText) {
    optInData.checkboxText = pseudoTagStringFromGQL(optInData.checkboxText);
  } else {
    delete optInData.checkboxText;
  }

  return {
    ...returnableField,
    editors: {
      optInData: {
        ...optInData,
      },
    },
  };
}

function toGQL(obj) {
  const name = setNameByType(obj);
  const { editors } = obj;
  const { optInData } = editors;
  const { hasDisclaimer, hasCheckbox, ...valueObj } = optInData;

  valueObj.disclaimer = hasDisclaimer ? pseudoTagStringToGQL(optInData.disclaimer) : '';
  valueObj.checkboxText = hasCheckbox ? pseudoTagStringToGQL(optInData.checkboxText) : '';
  valueObj.optInValue = hasCheckbox ? optInData.optInValue : '';

  return { value: valueObj, name };
}

function overrideToGQL(override) {
  const { editors } = override;
  const { optInData } = editors;
  const { ...valueObj } = optInData;

  if (valueObj.disclaimer) {
    valueObj.disclaimer = pseudoTagStringToGQL(valueObj.disclaimer);
  } else {
    delete valueObj.disclaimer;
  }

  if (valueObj.checkboxText) {
    valueObj.checkboxText = pseudoTagStringToGQL(optInData.checkboxText);
  } else {
    delete valueObj.checkboxText;
  }
  return { value: valueObj };
}

export default {
  fromGQL,
  overrideFromGQL,
  toGQL,
  overrideToGQL,
};
